import React from "react";

function Truck() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.637"
      height="13.852"
      viewBox="0 0 39.637 13.852"
    >
      <g transform="translate(.325 .325)">
        <path
          d="M251.462 38.037v-4.052a.4.4 0 01.4-.4h9.041"
          className="cls-1"
          transform="translate(-235.325 -33.58)"
        ></path>
        <path
          d="M235.007 55.355a3.027 3.027 0 01-5.7-1.412"
          className="cls-1"
          transform="translate(-224.239 -43.768)"
        ></path>
        <path
          d="M240.019 53.943a3.026 3.026 0 003.026 3.027h1.164"
          className="cls-1"
          transform="translate(-229.6 -43.768)"
        ></path>
        <path
          d="M272.609 55.355a3.027 3.027 0 01-5.7-1.412"
          className="cls-1"
          transform="translate(-243.051 -43.768)"
        ></path>
        <path
          d="M281.811 56.97h-1.164a3.027 3.027 0 01-3.027-3.027"
          className="cls-1"
          transform="translate(-248.413 -43.768)"
        ></path>
        <path
          d="M273.424 43.755h-6.053V33.58h5.612a1.165 1.165 0 011.1.8l1.6 3.292 6.125.465a.5.5 0 01.462.5v4.625l-2.344.5"
          className="cls-1"
          transform="translate(-243.284 -33.58)"
        ></path>
        <path
          d="M7.451 0H0"
          className="cls-1"
          transform="translate(17.636 10.176)"
        ></path>
        <path
          d="M269.7 35.208a.233.233 0 01.232-.232h3.784a.921.921 0 01.9.529l1.352 2.555a.233.233 0 01-.147.294.245.245 0 01-.073.011h-5.817a.233.233 0 01-.232-.232z"
          className="cls-1"
          transform="translate(-244.45 -34.277)"
        ></path>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M25.017 5.287h2.328a.7.7 0 01-.7.7h-.931a.7.7 0 01-.7-.7z"
          style={{ isolation: "isolate" }}
          opacity="0.2"
        ></path>
        <path
          d="M269.234 44.16h2.328a.466.466 0 01-.466.466h-1.4a.466.466 0 01-.466-.466z"
          className="cls-3"
          transform="translate(-244.217 -38.873)"
        ></path>
        <path
          fill="none"
          stroke="#2a2e43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0.284"
          d="M3.236 5.752h1.862a.7.7 0 01-.7.7h-.466a.7.7 0 01-.7-.7z"
          style={{ isolation: "isolate" }}
          opacity="0.1"
        ></path>
        <path
          d="M225.644 45.092h1.862a.466.466 0 01-.466.466h-.931a.466.466 0 01-.466-.466z"
          className="cls-3"
          transform="translate(-222.408 -39.34)"
        ></path>
        <path
          d="M286.469 50.447a3.492 3.492 0 00-6.985 0"
          className="cls-1"
          transform="translate(-249.345 -40.272)"
        ></path>
        <circle
          cx="3.026"
          cy="3.026"
          r="3.026"
          className="cls-1"
          transform="translate(30.373 7.149)"
        ></circle>
        <circle
          cx="1.513"
          cy="1.513"
          r="1.513"
          className="cls-5"
          transform="translate(31.886 8.663)"
        ></circle>
        <path
          d="M248.867 50.447a3.492 3.492 0 00-6.984 0"
          className="cls-1"
          transform="translate(-230.533 -40.272)"
        ></path>
        <circle
          cx="3.026"
          cy="3.026"
          r="3.026"
          className="cls-1"
          transform="translate(11.583 7.149)"
        ></circle>
        <circle
          cx="1.513"
          cy="1.513"
          r="1.513"
          className="cls-5"
          transform="translate(13.096 8.663)"
        ></circle>
        <path
          d="M255.724 38.712v-2.739a.233.233 0 01.466 0v2.565"
          className="cls-6"
          transform="translate(-237.457 -34.661)"
        ></path>
        <path
          d="M259.451 38.277v-2.3a.233.233 0 01.466 0V38.7"
          className="cls-6"
          transform="translate(-239.322 -34.661)"
        ></path>
        <path
          d="M263.178 38.845v-2.872a.233.233 0 01.466 0v2.588"
          className="cls-6"
          transform="translate(-241.187 -34.661)"
        ></path>
        <path
          d="M0 0h2.13"
          className="cls-7"
          transform="translate(36.832 7.956)"
        ></path>
        <path
          d="M9.651 0H0"
          className="cls-7"
          transform="translate(.146 8.098)"
        ></path>
        <path
          d="M296.259 44.812h-.359a.144.144 0 01-.1-.041l-.426-.426a.142.142 0 01.1-.242h.788z"
          className="cls-8"
          transform="translate(-257.272 -38.844)"
        ></path>
        <path
          d="M0 0h1.724a.406.406 0 01.406.406A1.014 1.014 0 011.116 1.42H0V0z"
          className="cls-8"
          transform="translate(0 5.258)"
        ></path>
        <path
          d="M.406 0H2.13v1.42H1.014A1.014 1.014 0 010 .406.406.406 0 01.406 0z"
          className="cls-8"
          transform="translate(6.18 5.258)"
        ></path>
        <path
          d="M236.42 45.522h-.62V44.1h1.19a.142.142 0 01.127.205l-.568 1.136a.143.143 0 01-.129.081z"
          className="cls-8"
          transform="translate(-227.488 -38.844)"
        ></path>
        <path
          d="M228.079 48.063h-7.688a.709.709 0 01-.674-.486l-.512-1.537a.712.712 0 01-.036-.224v-2.644a.71.71 0 01.71-.71h7.7"
          className="cls-8"
          transform="translate(-219.169 -38.024)"
        ></path>
        <path
          d="M239.147 48.063h-2.127a.71.71 0 01-.674-.486l-.512-1.537a.713.713 0 01-.036-.224v-3.354l15.777.019"
          className="cls-8"
          transform="translate(-227.488 -38.024)"
        ></path>
      </g>
    </svg>
  );
}

export default Truck;
